export class SendApproveRequest{
    EmployeesNo :string [];
    ApproveBy : string;
}